"use client";
import React from "react";
import { Button, Stack, Link, Paper, Box } from "@mui/material";
import { useTranslations } from "next-intl";
import { CustomTypographyComponent } from "../ui/text";
import {
  ResetPasswordForm,
  ResetPasswordFormState,
} from "../forms/ResetPasswordForm";
import { useTheme } from "@quales/utils/theme";
import { useSearchParams, useRouter } from "next/navigation";
import axios, { AxiosError } from "axios";
import { WcStack } from "@bpipartners/webui";

export const ResetPasswordComposite = ({
  loginHost,
}: {
  loginHost: string;
}) => {
  const t = useTranslations();
  const resetRef = React.useRef();
  const theme = useTheme();
  const router = useRouter();
  const searchParams = useSearchParams();
  const changePasswordID = searchParams.get("changePasswordID");

  const [failedReset, setFailedReset] = React.useState<boolean>(false);
  const [expiredResetLink, setExpiredResetLink] = React.useState(false);
  const [isSubmitted, setIsSubmitted] = React.useState<boolean>(false);

  const handleResetDetails = (val: ResetPasswordFormState) => {
    if (val && changePasswordID) {
      axios
        .post(
          loginHost + "/resetPassword",
          { NewPassword: val.password, ChangePasswordID: changePasswordID },
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            withCredentials: true,
          }
        )
        .then((res: any) => {
          if (res && res.data && res.data.Status === 200) {
            setFailedReset(false);
            setIsSubmitted(true);
            window.location.href = "/";
          } else {
            setFailedReset(true);
          }
        })
        .catch((FEerror: any) => {
          //@ts-ignore
          if (FEerror.response.status === 404) setExpiredResetLink(true);
        });
    }
  };

  const handleResetClicked = () => {
    if (resetRef && resetRef.current) {
      //@ts-ignore
      resetRef.current.onSubmit();
    }
  };
  const handleRetryResetClicked = () => {
    window.location.href = "/forgotpassword";
  };

  return (
    <Paper>
      <Stack
        alignItems="center"
        height="600px"
        width="600px"
        id="ResetPasswordComposite"
      >
        <WcStack padding={8}>
          <Box
            component="img"
            sx={{
              height: 100,
            }}
            //@ts-ignore
            alt={"Quales-logo"}
            src={"https://storage.googleapis.com/qualesstatic/quales-logo.png"}
          />
        </WcStack>
        <Stack
          mt={2}
          spacing={2}
          justifyContent={"center"}
          alignItems="center"
          width="100%"
        >
          <CustomTypographyComponent variant="h5">
            {t("login.resetPassword")}
          </CustomTypographyComponent>
          {!expiredResetLink && (
            <CustomTypographyComponent>
              {t("login.resetDetails")}
            </CustomTypographyComponent>
          )}
        </Stack>
        {isSubmitted && failedReset && !expiredResetLink && (
          <CustomTypographyComponent
            variant="body1"
            color={theme.appColors.error}
          >
            {t("login.failedPaswordReset")}
          </CustomTypographyComponent>
        )}
        {isSubmitted && !failedReset && (
          <CustomTypographyComponent
            variant="body1"
            color={theme.palette.primary.main}
          >
            {t("login.succeededPaswordReset")}
          </CustomTypographyComponent>
        )}

        {expiredResetLink && (
          <CustomTypographyComponent
            variant="body1"
            color={theme.appColors.error}
          >
            {t("login.resetExipred")}
          </CustomTypographyComponent>
        )}
        {changePasswordID === "" ||
          (changePasswordID === undefined && (
            <CustomTypographyComponent
              variant="body1"
              color={theme.appColors.error}
            >
              {t("login.noRessetToken")}
            </CustomTypographyComponent>
          ))}
        {!expiredResetLink && (
          <Stack justifyContent={"center"} alignItems="center" width="100%">
            <ResetPasswordForm
              formDisabled={changePasswordID === undefined || isSubmitted}
              onResetDetails={handleResetDetails}
              ref={resetRef}
            />
          </Stack>
        )}

        <Stack>
          {!expiredResetLink && (
            <Stack alignItems={"center"} width="100%">
              <Button
                color="primary"
                variant="contained"
                disabled={changePasswordID === undefined || isSubmitted}
                onClick={handleResetClicked}
                sx={{ mr: 1, width: "60%" }}
              >
                {t("login.reset")}
              </Button>
            </Stack>
          )}
          {expiredResetLink && (
            <Stack alignItems={"center"} width="100%">
              <Button
                color="primary"
                variant="contained"
                onClick={handleRetryResetClicked}
                sx={{ mr: 1, width: "100%", mt: 4 }}
              >
                {t("login.resetPassword")}
              </Button>
            </Stack>
          )}
        </Stack>
        <Stack mt={4}>
          {isSubmitted && !failedReset && (
            <Link href="/login">
              <CustomTypographyComponent color={theme.palette.primary.main}>
                {t("login.back2login")}
              </CustomTypographyComponent>
            </Link>
          )}
        </Stack>
      </Stack>
    </Paper>
  );
};

export default ResetPasswordComposite;
